import { render, staticRenderFns } from "./SelecionaEmpresa.vue?vue&type=template&id=68d36566"
import script from "./SelecionaEmpresa.vue?vue&type=script&lang=js"
export * from "./SelecionaEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports